import apiClient from '../apiClient';
import { GET_USER_PROFILE_ACCOUNT_MANAGER_BY_COMPANY_URL } from '../apiUrl';

const getAccountManagerByCompanyApi = () => {
  return apiClient.get(GET_USER_PROFILE_ACCOUNT_MANAGER_BY_COMPANY_URL);
};

export default getAccountManagerByCompanyApi;
